var _g, _path, _g2, _g3, _path2, _g4, _path3, _g5, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup472(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 383,
    height: 401,
    viewBox: "0 0 383 401",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_580_262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238 64C238 91.6142 215.614 114 188 114C160.386 114 138 91.6142 138 64C138 36.3858 160.386 14 188 14C215.614 14 238 36.3858 238 64Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M175.022 58.46H176.682V76.58H175.022V58.46ZM167.142 59.86C169.822 59.86 171.742 62.32 171.742 66.16C171.742 70.02 169.822 72.48 167.142 72.48C164.482 72.48 162.562 70.02 162.562 66.16C162.562 62.32 164.482 59.86 167.142 59.86ZM167.142 61.36C165.382 61.36 164.142 63.24 164.142 66.16C164.142 69.1 165.382 71.02 167.142 71.02C168.922 71.02 170.142 69.1 170.142 66.16C170.142 63.24 168.922 61.36 167.142 61.36ZM184.321 64.6H185.961V68.02H184.321V64.6ZM190.961 64.6H192.601V68.02H190.961V64.6ZM180.281 67.42H196.621V68.76H180.281V67.42ZM188.441 70.12C192.321 70.12 194.641 71.26 194.641 73.32C194.641 75.38 192.321 76.54 188.441 76.54C184.561 76.54 182.241 75.38 182.241 73.32C182.241 71.26 184.561 70.12 188.441 70.12ZM188.441 71.4C185.621 71.4 183.921 72.1 183.921 73.32C183.921 74.56 185.621 75.24 188.441 75.24C191.281 75.24 192.961 74.56 192.961 73.32C192.961 72.1 191.281 71.4 188.441 71.4ZM188.461 58.8C192.381 58.8 194.821 60.06 194.821 62.18C194.821 64.28 192.381 65.52 188.461 65.52C184.521 65.52 182.101 64.28 182.101 62.18C182.101 60.06 184.521 58.8 188.461 58.8ZM188.461 60.1C185.581 60.1 183.801 60.86 183.801 62.18C183.801 63.48 185.581 64.24 188.461 64.24C191.341 64.24 193.121 63.48 193.121 62.18C193.121 60.86 191.341 60.1 188.461 60.1ZM203.159 61.06H204.479V64C204.479 67.76 202.179 71.64 199.359 73.08L198.399 71.76C200.979 70.5 203.159 67.06 203.159 64V61.06ZM203.459 61.06H204.779V64C204.779 66.86 206.819 70.08 209.439 71.32L208.499 72.64C205.639 71.22 203.459 67.58 203.459 64V61.06ZM199.039 60.32H208.779V61.72H199.039V60.32ZM210.919 58.48H212.599V76.56H210.919V58.48ZM212.199 65.78H215.559V67.18H212.199V65.78Z",
    fill: "black"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_580_262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124 187C124 214.614 101.614 237 74 237C46.3858 237 24 214.614 24 187C24 159.386 46.3858 137 74 137C101.614 137 124 159.386 124 187Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_580_262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359 187C359 214.614 336.614 237 309 237C281.386 237 259 214.614 259 187C259 159.386 281.386 137 309 137C336.614 137 359 159.386 359 187Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M282.902 196.78H299.282V198.18H282.902V196.78ZM284.822 183.78H286.462V187.1H295.682V183.78H297.322V193.2H284.822V183.78ZM286.462 188.44V191.84H295.682V188.44H286.462ZM314.941 182.48H316.521V195.94H314.941V182.48ZM312.041 187.88H315.441V189.26H312.041V187.88ZM310.961 182.82H312.521V195.44H310.961V182.82ZM304.741 198.8H317.081V200.16H304.741V198.8ZM304.741 194.72H306.401V199.28H304.741V194.72ZM302.121 191.9H303.281C305.821 191.9 307.701 191.82 309.921 191.38L310.081 192.72C307.801 193.16 305.901 193.26 303.281 193.26H302.121V191.9ZM302.081 184.04H308.881V189.2H303.721V192.62H302.121V187.94H307.281V185.38H302.081V184.04ZM321.759 191.14H334.179V192.5H321.759V191.14ZM319.699 196.74H336.079V198.12H319.699V196.74ZM321.759 184.14H333.999V185.52H323.419V191.74H321.759V184.14Z",
    fill: "black"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_580_262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240 317C240 344.614 217.614 367 190 367C162.386 367 140 344.614 140 317C140 289.386 162.386 267 190 267C217.614 267 240 289.386 240 317Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M181.202 323.88C185.042 323.88 187.502 325.14 187.502 327.22C187.502 329.28 185.042 330.52 181.202 330.52C177.342 330.52 174.902 329.28 174.902 327.22C174.902 325.14 177.342 323.88 181.202 323.88ZM181.202 325.18C178.362 325.18 176.542 325.96 176.542 327.22C176.542 328.46 178.362 329.24 181.202 329.24C184.042 329.24 185.842 328.46 185.842 327.22C185.842 325.96 184.042 325.18 181.202 325.18ZM175.042 313.38H186.682V314.74H175.042V313.38ZM173.102 320.9H189.422V322.24H173.102V320.9ZM179.802 317.42H181.442V321.28H179.802V317.42ZM185.722 313.38H187.342V314.92C187.342 316.38 187.342 317.84 186.862 319.72L185.222 319.52C185.722 317.66 185.722 316.34 185.722 314.92V313.38ZM203.86 312.48H205.52V325.7H203.86V312.48ZM205 317.96H208.2V319.34H205V317.96ZM198.92 313.88H200.68C200.68 318.56 197.4 321.98 192.22 323.64L191.5 322.28C196.06 320.88 198.92 318.08 198.92 314.6V313.88ZM192.24 313.88H199.76V315.24H192.24V313.88ZM194.24 328.8H206.32V330.16H194.24V328.8ZM194.24 324.36H195.9V329.34H194.24V324.36Z",
    fill: "black"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_580_262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124 187C124 214.614 101.614 237 74 237C46.3858 237 24 214.614 24 187C24 159.386 46.3858 137 74 137C101.614 137 124 159.386 124 187Z",
    fill: "white"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5031 183.86C46.1631 183.86 48.0431 186.32 48.0431 190.16C48.0431 194.02 46.1631 196.48 43.5031 196.48C40.8431 196.48 38.9631 194.02 38.9631 190.16C38.9631 186.32 40.8431 183.86 43.5031 183.86ZM43.5031 185.36C41.7431 185.36 40.5431 187.24 40.5431 190.16C40.5431 193.1 41.7431 195.02 43.5031 195.02C45.2431 195.02 46.4631 193.1 46.4631 190.16C46.4631 187.24 45.2431 185.36 43.5031 185.36ZM50.9231 182.48H52.6031V200.56H50.9231V182.48ZM52.2031 189.7H55.5631V191.1H52.2031V189.7ZM58.2416 194.84H59.6816C63.0616 194.84 65.4216 194.74 68.2016 194.28L68.3616 195.62C65.5216 196.12 63.1216 196.22 59.6816 196.22H58.2416V194.84ZM58.2416 184.12H67.0016V185.5H59.8816V195.32H58.2416V184.12ZM59.4816 189.18H66.3416V190.52H59.4816V189.18ZM70.2616 182.48H71.9216V200.56H70.2616V182.48ZM82.74 183.72H84.18V185.1C84.18 189.04 80.52 192.1 76.9 192.92L76.16 191.54C79.34 190.94 82.74 188.18 82.74 185.1V183.72ZM83.04 183.72H84.48V185.1C84.48 188.2 87.9 190.94 91.06 191.54L90.32 192.92C86.72 192.1 83.04 189.06 83.04 185.1V183.72ZM75.5 196.76H91.88V198.12H75.5V196.76ZM95.9984 192.22H108.418V193.56H95.9984V192.22ZM93.8984 196.86H110.278V198.24H93.8984V196.86ZM95.9984 184.02H108.218V185.38H97.6784V192.64H95.9984V184.02ZM97.1384 188.06H107.838V189.38H97.1384V188.06Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M235.063 172.555C235.649 171.969 235.649 171.02 235.063 170.434L225.518 160.888C224.932 160.302 223.982 160.302 223.396 160.888C222.81 161.474 222.81 162.423 223.396 163.009L231.881 171.494L223.396 179.98C222.81 180.565 222.81 181.515 223.396 182.101C223.982 182.687 224.932 182.687 225.518 182.101L235.063 172.555ZM146.997 172.994H234.003V169.994H146.997V172.994Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M235.063 172.555C235.649 171.969 235.649 171.02 235.063 170.434L225.518 160.888C224.932 160.302 223.982 160.302 223.396 160.888C222.81 161.474 222.81 162.423 223.396 163.009L231.881 171.494L223.396 179.98C222.81 180.565 222.81 181.515 223.396 182.101C223.982 182.687 224.932 182.687 225.518 182.101L235.063 172.555ZM146.997 172.994H234.003V169.994H146.997V172.994Z",
    fill: "#EC7538"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M143.937 207.439C143.351 208.025 143.351 208.975 143.937 209.561L153.483 219.107C154.068 219.692 155.018 219.692 155.604 219.107C156.19 218.521 156.19 217.571 155.604 216.985L147.119 208.5L155.604 200.015C156.19 199.429 156.19 198.479 155.604 197.893C155.018 197.308 154.068 197.308 153.483 197.893L143.937 207.439ZM235.003 207L144.997 207V210L235.003 210V207Z",
    fill: "#EC7538"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M129.861 295.494C130.685 295.57 131.417 294.964 131.494 294.139L132.748 280.698C132.825 279.873 132.219 279.142 131.394 279.065C130.569 278.988 129.838 279.594 129.761 280.419L128.646 292.367L116.698 291.252C115.873 291.175 115.142 291.781 115.065 292.606C114.988 293.431 115.594 294.162 116.419 294.239L129.861 295.494ZM94.8454 253.958L128.845 294.958L131.155 293.042L97.1546 252.042L94.8454 253.958Z",
    fill: "#EC7538"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M232.013 101.605C231.187 101.532 230.46 102.143 230.388 102.968L229.211 116.417C229.139 117.242 229.749 117.97 230.575 118.042C231.4 118.114 232.128 117.504 232.2 116.678L233.246 104.724L245.2 105.77C246.025 105.842 246.753 105.232 246.825 104.406C246.897 103.581 246.287 102.853 245.461 102.781L232.013 101.605ZM267.268 142.937L233.031 102.135L230.733 104.063L264.97 144.865L267.268 142.937Z",
    fill: "#EC7538"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5059 128.933C94.5781 129.758 95.3056 130.369 96.1309 130.296L109.58 129.12C110.405 129.048 111.015 128.32 110.943 127.495C110.871 126.67 110.143 126.059 109.318 126.131L97.3637 127.177L96.3179 115.223C96.2457 114.398 95.5181 113.787 94.6929 113.859C93.8676 113.931 93.2571 114.659 93.3293 115.484L94.5059 128.933ZM129.088 87.0358L94.8511 127.838L97.1493 129.766L131.386 88.9642L129.088 87.0358Z",
    fill: "#EC7538"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M283.106 130.296C283.932 130.369 284.659 129.758 284.731 128.933L285.908 115.484C285.98 114.659 285.37 113.931 284.544 113.859C283.719 113.787 282.992 114.398 282.919 115.223L281.874 127.177L269.919 126.131C269.094 126.059 268.366 126.67 268.294 127.495C268.222 128.32 268.832 129.048 269.658 129.12L283.106 130.296ZM247.851 88.9642L282.088 129.766L284.386 127.838L250.149 87.0358L247.851 88.9642Z",
    fill: "#EC7538"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M270.731 235.869C270.659 235.044 269.932 234.434 269.106 234.506L255.658 235.682C254.832 235.755 254.222 236.482 254.294 237.307C254.366 238.133 255.094 238.743 255.919 238.671L267.874 237.625L268.919 249.579C268.992 250.405 269.719 251.015 270.544 250.943C271.37 250.871 271.98 250.143 271.908 249.318L270.731 235.869ZM236.149 277.766L270.386 236.964L268.088 235.036L233.851 275.838L236.149 277.766Z",
    fill: "#EC7538"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M247.506 294.933C247.578 295.758 248.306 296.369 249.131 296.297L262.58 295.12C263.405 295.048 264.015 294.32 263.943 293.495C263.871 292.67 263.143 292.059 262.318 292.131L250.364 293.177L249.318 281.223C249.246 280.398 248.518 279.787 247.693 279.859C246.868 279.931 246.257 280.659 246.329 281.484L247.506 294.933ZM282.088 253.036L247.851 293.838L250.149 295.766L284.386 254.964L282.088 253.036Z",
    fill: "#EC7538"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M148.731 102.869C148.659 102.044 147.932 101.434 147.106 101.506L133.658 102.682C132.832 102.755 132.222 103.482 132.294 104.307C132.366 105.133 133.094 105.743 133.919 105.671L145.874 104.625L146.919 116.579C146.992 117.405 147.719 118.015 148.544 117.943C149.37 117.871 149.98 117.143 149.908 116.318L148.731 102.869ZM114.149 144.766L148.386 103.964L146.088 102.036L111.851 142.838L114.149 144.766Z",
    fill: "#EC7538"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M148.731 102.869C148.659 102.044 147.932 101.434 147.106 101.506L133.658 102.682C132.832 102.755 132.222 103.482 132.294 104.307C132.366 105.133 133.094 105.743 133.919 105.671L145.874 104.625L146.919 116.579C146.992 117.405 147.719 118.015 148.544 117.943C149.37 117.871 149.98 117.143 149.908 116.318L148.731 102.869ZM114.149 144.766L148.386 103.964L146.088 102.036L111.851 142.838L114.149 144.766Z",
    fill: "#EC7538"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M113.131 231.506C112.306 231.434 111.578 232.044 111.506 232.869L110.329 246.318C110.257 247.143 110.868 247.871 111.693 247.943C112.518 248.015 113.246 247.405 113.318 246.579L114.364 234.625L126.318 235.671C127.143 235.743 127.871 235.133 127.943 234.307C128.015 233.482 127.405 232.755 126.58 232.682L113.131 231.506ZM148.386 272.838L114.149 232.036L111.851 233.964L146.088 274.766L148.386 272.838Z",
    fill: "#EC7538"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_580_262",
    x: 114,
    y: 0,
    width: 148,
    height: 148,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.388333 0 0 0 0 0.388333 0 0 0 0 0.388333 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_580_262"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_580_262",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_580_262",
    x: 0,
    y: 123,
    width: 148,
    height: 148,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.388333 0 0 0 0 0.388333 0 0 0 0 0.388333 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_580_262"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_580_262",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_580_262",
    x: 235,
    y: 123,
    width: 148,
    height: 148,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.388333 0 0 0 0 0.388333 0 0 0 0 0.388333 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_580_262"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_580_262",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_580_262",
    x: 116,
    y: 253,
    width: 148,
    height: 148,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.388333 0 0 0 0 0.388333 0 0 0 0 0.388333 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_580_262"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_580_262",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_580_262",
    x: 0,
    y: 123,
    width: 148,
    height: 148,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.388333 0 0 0 0 0.388333 0 0 0 0 0.388333 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_580_262"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_580_262",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup472);
export default __webpack_public_path__ + "static/media/Group 472.9775d90d18cdeb869bfd580e50b0eced.svg";
export { ForwardRef as ReactComponent };